import React from 'react';

interface TelegramLogoProps {
    width?: number;
    height?: number;
    color?: string;
    className?: string;
}

const TelegramLogo: React.FC<TelegramLogoProps> = ({ width = 24, height = 24, color = '#1F1F1F', className }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
            fill="#E3ECF3"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.97943 11.8838C9.18615 10.4867 11.3245 9.56565 12.3944 9.12064C15.4492 7.85003 16.084 7.62931 16.4977 7.62203C16.5887 7.62042 16.7922 7.64297 16.9239 7.74992C17.0352 7.84021 17.0658 7.9622 17.0805 8.04781C17.0951 8.13342 17.1134 8.32845 17.0989 8.48084C16.9333 10.2202 16.2171 14.4412 15.8526 16.3893C15.6984 17.2136 15.3948 17.49 15.1009 17.517C14.4621 17.5758 13.977 17.0949 13.3583 16.6893C12.3902 16.0547 11.8433 15.6596 10.9035 15.0403C9.81746 14.3247 10.5215 13.9313 11.1404 13.2885C11.3024 13.1202 14.1169 10.5602 14.1714 10.328C14.1782 10.2989 14.1845 10.1906 14.1202 10.1335C14.0559 10.0763 13.961 10.0959 13.8925 10.1114C13.7954 10.1334 12.2488 11.1557 9.25261 13.1782C8.81361 13.4796 8.41597 13.6265 8.05971 13.6188C7.66695 13.6103 6.91144 13.3967 6.3498 13.2142C5.66093 12.9903 5.11342 12.8719 5.1611 12.4916C5.18593 12.2935 5.45871 12.0909 5.97943 11.8838Z"
            fill={color}
        />
    </svg>
);

export default TelegramLogo;
